import { MODIFY_INVOICE, MODIFY_INVOICE_ITEM_VALUE } from './actionTypes'

export const setModifyInvoice = (key, value) => dispatch => new Promise(resolve => {
	dispatch({
		type: MODIFY_INVOICE,
		payload: {
			key,
			value,
		},
	})
	resolve(true)
})

export const modifyItemValue = (key, value, index) => dispatch => new Promise(resolve => {
	dispatch({
		type: MODIFY_INVOICE_ITEM_VALUE,
		payload: {
			key,
			value,
			index,
		},
	})
	resolve(true)
})
